export default __webpack_public_path__ + "static/media/3.e393ad3c.png";